// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".dialog-subtitle[data-v-0a8be962] {\n  color: #606266;\n  font-weight: 500;\n}", "",{"version":3,"sources":["/builds/front/game-platform-web/src/pages/admin/member/components/v2/BetHistoryDialogV2.vue"],"names":[],"mappings":"AACA;EACE,cAAA;EACA,gBAAA;AAAF","file":"BetHistoryDialogV2.vue","sourcesContent":["\n.dialog-subtitle {\n  color: #606266;\n  font-weight: 500;\n}\n"]}]);
// Exports
module.exports = exports;
